/**
 * Hero Section - Landing Page
 * Refactored for new design system and structure
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import BRANDING from '../../../../config/branding';
import { Button } from '../../../../design-system';
import { ROUTES } from '../../../../config/routes';

const Hero = ({ language }) => {
  const isArabic = language === 'ar';
  const navigate = useNavigate();

  const content = isArabic
    ? {
        headline: `إرسال كود التحقق عبر ${BRANDING.ar} فوراً`,
        subheadline: `منصة ${BRANDING.ar}: آمنة وسريعة وموثوقة لخدمات OTP ودعم للسوق العربي`,
        cta1: 'ابدأ الآن',
        cta2: 'اعرف المزيد',
      }
    : {
        headline: `Instant OTP Delivery with ${BRANDING.en}`,
        subheadline: `${BRANDING.en}: Secure, fast, and reliable authentication supporting the Arab market`,
        cta1: 'Get Started',
        cta2: 'Learn More',
      };

  return (
    <section
      id="home"
      className="w-full py-16 sm:py-24 md:py-32 lg:py-48 px-4 sm:px-6 bg-[#0B0E14] relative overflow-hidden"
    >
      {/* Animated gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#128C7E]/20 via-transparent to-[#128C7E]/5 pointer-events-none" />
      <div className="absolute top-1/2 right-0 w-64 h-64 sm:w-96 sm:h-96 bg-[#128C7E]/10 rounded-full blur-3xl pointer-events-none" />
      
      <div className="relative max-w-6xl mx-auto text-center">
        <h1 className="text-3xl xs:text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 sm:mb-8 leading-tight">
          {content.headline}
        </h1>
        
        <p className="text-sm sm:text-base md:text-lg lg:text-2xl text-[#A0AEC0] mb-8 sm:mb-12 max-w-3xl mx-auto leading-relaxed font-light">
          {content.subheadline}
        </p>
        
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 justify-center items-center">
          <Button
            variant="primary"
            size="lg"
            className="w-full"
            onClick={() => navigate(ROUTES.LOGIN)}
          >
            {content.cta1}
          </Button>
          <Button
            variant="outline"
            size="lg"
            className="w-full"
            onClick={() => {
              const scrollAmount = 600;
              const startY = window.scrollY;
              const duration = 1200; // ms
              const startTime = performance.now();

              function animateScroll(currentTime) {
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const ease = progress < 0.5
                  ? 2 * progress * progress
                  : -1 + (4 - 2 * progress) * progress;
                window.scrollTo({
                  top: startY + (scrollAmount * ease),
                  behavior: 'auto',
                });
                if (progress < 1) {
                  requestAnimationFrame(animateScroll);
                }
              }
              requestAnimationFrame(animateScroll);
            }}
          >
            {content.cta2}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
